import { getAnalyticsConsent, subscribeAnalyticsConsent } from "@repo/shared/analyticsConsent";

interface ReplayController {
  stop(): Promise<void>;
  resume(): void | Promise<void>;
}

/** Serialize stop/start so a slow shutdown cannot override a newer choice. */
export function observeReplayConsent(createReplay: () => ReplayController): () => void {
  let replay: ReplayController | undefined;
  let previous: boolean | undefined;
  let disposed = false;
  let pending: Promise<unknown> = Promise.resolve();
  const update = () => {
    const accepted = getAnalyticsConsent() === "accepted";
    if (accepted === previous) return;
    previous = accepted;
    pending = pending.then(async () => {
      if (disposed) return;
      if (getAnalyticsConsent() !== "accepted") {
        await replay?.stop();
      } else if (!replay) {
        replay = createReplay();
      } else {
        await replay.resume();
      }
    }).catch(() => { /* Recording failures must not break the application. */ });
  };
  const unsubscribe = subscribeAnalyticsConsent(update);
  update();
  return () => {
    disposed = true;
    unsubscribe();
    void pending.then(() => replay?.stop()).catch(() => {});
  };
}
